module.exports = __webpack_public_path__ + "img/btn-in.3e596a9f.png";